import React, { type FC } from 'react';

import { Anchor, xcss } from '@atlaskit/primitives';

const LinkStyle = xcss({
	':focus-visible': {
		outlineStyle: 'auto',
	},
});

type TableCellDataLinkProps = {
	href: string;
	target?: '_blank' | '_self' | '_parent' | '_top';
	onClick?: () => void;
	children?: React.ReactNode;
};

export const TableCellDataLink: FC<TableCellDataLinkProps> = ({
	children,
	href,
	target = '_top',
	onClick,
}) => {
	return (
		<Anchor href={href} target={target} xcss={LinkStyle} onClick={onClick}>
			{children}
		</Anchor>
	);
};
